import PropTypes from "prop-types";
import { useState, useEffect } from "react";

const UsuarioVerHalconForm = ({ user, getUsers, setSelectedSection}) => {
  const [usuariosList, setUsuariosList] = useState([]);
  const [searchTerm, setSearchTerm] = useState(''); // Estado para la búsqueda

  useEffect(() => {
    const userId = user;

    const fetchUsuarios = async () => {
      if (!userId) return;
      try {
        const usuariosData = await getUsers();
        const data = Array.isArray(usuariosData.data) ? usuariosData.data : [];
        
        // Filter out rows where 'fecha_eliminacion' does not meet the validation criteria
        const filteredData = data.filter(row => {
          if (!row.fecha_eliminacion) return true; // Keep row if 'fecha_eliminacion' is undefined or null
          const fechaEliminacion = row.fecha_eliminacion;
          //return fechaEliminacion === "0000-00-00 00:00:00" || fechaEliminacion === "1900-01-01 00:00:00";
          return fechaEliminacion
        });
        
        setUsuariosList(filteredData);
      } catch (error) {
        console.error("Error fetching usuarios:", error);
        setUsuariosList([]);
      }
    };

    fetchUsuarios();
  }, [user, getUsers]);

  const filteredUsuarios = usuariosList.filter(usuario => {
    const monthName = new Date(usuario.fecha_nacimiento).toLocaleDateString("es-ES", { month: "long" }).toLowerCase();
  
    return (
      usuario.pago.toString().includes(searchTerm) ||
      usuario.padrino.toLowerCase().includes(searchTerm.toLowerCase()) ||
      usuario.nombre_completo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      monthName.includes(searchTerm.toLowerCase()) // Filter by month
    );
  });
  
  // Función para calcular la edad basada en fecha de nacimiento
  const getEdad = (dateString) => {
    const today = new Date(); // Fecha actual
    const birthDate = new Date(dateString); // Convertir la fecha de nacimiento a un objeto Date
    let age = today.getFullYear() - birthDate.getFullYear(); // Calcular la diferencia en años
    const monthDifference = today.getMonth() - birthDate.getMonth(); // Diferencia en meses

    // Ajustar si el mes y el día de nacimiento aún no han pasado este año
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age; // Retornar la edad calculada
  };

  // Función para formatear la fecha
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
  
    // Crear fecha como UTC
    const utcDate = new Date(dateString);
  
    // Ajustar a GMT-6 (360 minutos = 6 horas)
    const localDate = new Date(utcDate.getTime() + 24 * 60 * 60 * 1000);
  
    // Formatear la fecha a 'DD-MM-YYYY'
    return localDate.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "long",
    });
  };

  return (
    <div>
      <h3>Halcones Registrados:</h3>
      
      <input 
        type="text" 
        placeholder="Buscar por ID, Nombre Completo o Alias..." 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.target.value)} 
        style={{ padding: '5px', minWidth:"244px", marginBottom: '20px' }} 
      />

    <div className="table-container">
      <table border="1" className="table">
        <thead className="table-th">
          <tr>
            <th>ID</th>
            <th>Nombre Completo</th>
            <th>Ultimo Pago</th>
            <th>Nombre Padrino</th>
            <th>Fecha Cumpleaños</th>

          </tr>
        </thead>
        <tbody>
          {filteredUsuarios.length > 0 ? (
            filteredUsuarios.map((usuario, index) => {
              const edad = getEdad(usuario.fecha_nacimiento);
              const isDeleted = usuario.fecha_eliminacion !== null;
              const rowStyle = {
                backgroundColor: isDeleted
                  ? 'rgba(170, 170, 170, 1)'
                  : edad < 14
                  ? '#cdacee'
                  : usuario.pago === "cuota ene-mar 2025"
                  ? '#c5f7d7'
                  : usuario.pago === "cuota abr-jun 2025"
                  ? '#17d4b4'
                  : usuario.pago === "cuota jul-sep 2025"
                  ? '#2a9db1'
                  : usuario.pago === "cuota oct-dic 2025"
                  ? '#3065b4'
                  : usuario.pago === "cuota ene-mar 2026"
                  ? '#ffab3dff'
                  : usuario.pago === "cuota abr-jun 2026"
                  ? '#bd7e2dff'
                  : usuario.pago === "cuota jul-sep 2026"
                  ? '#d2474e'
                  : usuario.pago === "cuota oct-dic 2026"
                  ? '#e8ce3d'
                  : usuario.pago === "cuota ene-mar 2027"
                  ? '#6ca6fe'
                  : usuario.pago === "cuota abr-jun 2027"
                  ? '#2ad655'
                  : usuario.pago === "cuota jul-sep 2027"
                  ? '#b02cdc'
                  : usuario.pago === "cuota oct-dic 2027"
                  ? '#63f3f3'
                  : 'rgba(170, 170, 170, 1)',
              };


              return (
                <tr key={index} style={rowStyle}>
                  <td width="30px">{usuario.id_usuario}</td>
                  <td width="250px">{usuario.nombre_completo}</td>
                  <td>{usuario.pago}</td>
                  <td width="150px">{usuario.padrino}</td>
                  <td>{formatDate(usuario.fecha_nacimiento)}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="16">No se encontraron usuarios.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>


    </div>
  );
};

UsuarioVerHalconForm.propTypes = {
  user: PropTypes.object,
  getUsers: PropTypes.func,
  setSelectedSection: PropTypes.func,
};

export default UsuarioVerHalconForm;
